export const MOSCOW_CENTER = [55.751244, 37.618423]

export function defaultMapCenter(user) {
  if (user?.city_lat != null && user?.city_lng != null) {
    return [user.city_lat, user.city_lng]
  }
  return MOSCOW_CENTER
}
